import { Box } from '@chakra-ui/react'
import { iCompetenciaPDI } from '../../../../../interfaces'
import { Container } from './styles'

interface iTabelaProps {
  dados: iCompetenciaPDI[]
}

export const TabelaCompetencias: React.FC<iTabelaProps> = ({ dados }) => {
  return (
    <Container>
      <thead>
        <tr>
          <th>Competências</th>
          <th>Total de colaboradores</th>
        </tr>
      </thead>
      <tbody>
        {
          dados.slice(3, dados.length).map((e, i) => {
            return (
              <Box as={'tr'} key={i}>
                <th><Box as='span' color={'var(--Azul)'}>{e.nome}</Box></th>
                <th style={{ display: 'flex', justifyContent: 'end' }}>{e.colaboradores}</th>
              </Box>
            )
          })
        }
      </tbody>
    </Container>
  )
}
